import { SERVICES } from "@/content/site";
import { Reveal, ProposedBadge, IconTile } from "./primitives";

export const ServicesGrid = () => (
  <div data-testid="services-grid" className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
    {SERVICES.map((s, i) => (
      <Reveal key={s.title} delay={(i % 3) * 0.07} className={s.span || ""}>
        <article data-testid={`service-card-${i}`} className="card-soft card-soft-hover flex h-full flex-col p-7 sm:p-8">
          <div className="flex items-start justify-between gap-4">
            <IconTile icon={s.icon} tone={i % 3 === 1 ? "plum" : "teal"} />
            <ProposedBadge />
          </div>
          <h3 className="mt-8 text-xl font-semibold leading-snug">{s.title}</h3>
          <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-slate">{s.body}</p>
        </article>
      </Reveal>
    ))}
  </div>
);
